(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-featured-drop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ds-editorial-countdown')) {
    customElements.define('ds-editorial-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else { this.initialize(); }
      }

      initialize() {
        const options = { signal: this.controller.signal };
        this.values = Array.from(this.querySelectorAll('[data-value]'));
        this.status = this.querySelector('[data-countdown-status]');
        this.date = this.querySelector('[data-launch-date]');
        this.clock = this.querySelector('[data-clock]');
        this.error = this.querySelector('[data-countdown-error]');
        this.setState('waiting');
        if (this.error) this.error.hidden = true;
        this.target = this.parseDeadline((this.dataset.deadline || '').trim());
        if (!Number.isFinite(this.target)) {
          if (this.error) this.error.hidden = false;
          if (this.date) this.date.hidden = true;
          return;
        }
        if (this.date) {
          try {
            this.date.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', { timeZone: 'Europe/Amsterdam', day: '2-digit', month: 'short', year: 'numeric' }).format(this.target);
          } catch (_) { this.date.textContent = new Date(this.target).toISOString().slice(0, 10); }
          this.date.hidden = false;
        }
        document.addEventListener('visibilitychange', () => {
          this.stop();
          if (!document.hidden) this.start();
        }, options);
        if (document.hidden) this.update();
        else this.start();
      }

      parseDeadline(raw) {
        const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-](\d{2}):(\d{2}))$/);
        if (!match) return NaN;
        const [, y, mo, d, h, mi, se = '00', zone, zh = '00', zm = '00'] = match;
        const year = Number(y), month = Number(mo), day = Number(d);
        const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year < 1000 || month < 1 || month > 12 || day < 1 || day > days[month - 1] || Number(h) > 23 || Number(mi) > 59 || Number(se) > 59 || Number(zh) > 14 || Number(zm) > 59 || (Number(zh) === 14 && Number(zm) !== 0)) return NaN;
        return Date.parse(`${y}-${mo}-${d}T${h}:${mi}:${se}${zone}`);
      }

      setState(state) {
        this.dataset.state = state;
        const text = this.dataset[state] || '';
        if (this.status && this.status.textContent !== text) this.status.textContent = text;
        if (this.clock) this.clock.hidden = state === 'waiting';
      }

      update() {
        const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const units = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        this.values.forEach((node) => {
          const value = String(units[node.dataset.value]).padStart(node.dataset.value === 'days' ? 3 : 2, '0');
          if (node.textContent !== value) node.textContent = value;
          node.style.setProperty('--dre-number-scale', value.length > 3 ? String(3 / value.length) : '1');
        });
        if (remaining === 0) {
          this.setState('finished');
          this.stop();
          return false;
        }
        if (this.dataset.state !== 'running') this.setState('running');
        return true;
      }

      start() { this.stop(); if (this.update()) this.timer = window.setInterval(() => this.update(), 1000); }
      stop() { window.clearInterval(this.timer); this.timer = null; }
      disconnectedCallback() { this.stop(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-main-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-page-surface')) {
    customElements.define('ds-page-surface', class extends HTMLElement {
      connectedCallback() {
        this.refreshScrollableContent();
        if ('ResizeObserver' in window) {
          this.dsResizeObserver = new ResizeObserver(() => this.refreshScrollableContent());
          this.dsResizeObserver.observe(this);
        }
      }
      disconnectedCallback() {
        this.dsResizeObserver?.disconnect();
      }
      refreshScrollableContent() {
        this.querySelectorAll('.dmp-richtext table, .dmp-richtext pre').forEach((element) => {
          const overflows = element.scrollWidth > element.clientWidth + 1;
          if (overflows && !element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '0');
            element.setAttribute('data-ds-scroll-focus', '');
          } else if (!overflows && element.hasAttribute('data-ds-scroll-focus')) {
            element.removeAttribute('tabindex');
            element.removeAttribute('data-ds-scroll-focus');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-saints-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-saints-studio')) {
    customElements.define('ds-saints-studio', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('.dss-dialog');
        this.cards = Array.from(this.querySelectorAll('[data-studio-card]'));
        if (!this.dialog) return;
        if (this.dialog.open) this.dialog.close();
        if (typeof this.dialog.showModal === 'function') {
          this.querySelectorAll('[data-studio-open]').forEach((opener) => {
            opener.setAttribute('aria-haspopup', 'dialog');
            opener.setAttribute('aria-controls', this.dialog.id);
          });
        }

        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-studio-open]');
          if (opener && this.contains(opener)) {
            const card = this.cards.find((item) => item.dataset.studioCard === opener.dataset.studioOpen);
            if (!card) return;
            if (typeof this.dialog.showModal !== 'function') {
              if (opener.matches('a')) card.open = true;
              return;
            }
            event.preventDefault();
            this.openCard(card, opener);
          }
          if (event.target.closest('[data-studio-close]')) this.closeDialog();
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeDialog();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          if (this.dialog.open) return;
          this.restoreScroll();
          if (this.lastOpener?.isConnected) this.lastOpener.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeDialog();
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.querySelectorAll('[data-studio-marker]').forEach((marker) => {
            marker.toggleAttribute('data-editor-selected', marker.dataset.studioOpen === String(event.detail.blockId));
          });
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.querySelectorAll('[data-editor-selected]').forEach((marker) => marker.removeAttribute('data-editor-selected'));
        }, options);
      }

      openCard(card, opener) {
        this.lastOpener = opener;
        this.dialog.querySelector('[data-studio-dialog-title]').textContent = card.querySelector('[data-studio-title]').textContent;
        const content = card.querySelector('[data-studio-detail]').cloneNode(true);
        content.querySelectorAll('img').forEach((img) => img.loading = 'eager');
        this.dialog.querySelector('[data-studio-dialog-body]').replaceChildren(content);
        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        if (!this.scrollLocked) {
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.scrollLocked = true;
        }
        this.dialog.querySelector('[data-studio-close]').focus({ preventScroll: true });
      }

      restoreScroll() {
        if (this.scrollLocked) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.scrollLocked = false;
        }
      }

      closeDialog() {
        this.dialog.close();
        this.restoreScroll();
        if (this.lastOpener?.isConnected) this.lastOpener.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
